module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/cart-2-d5374bc5c5e2c05979d341a2eec98c5a.svg";